import React from "react";
import { Link } from "react-router-dom";
import LogoImg from "../../assets/home/bacchus-about-us.svg";
import TociliceImg from "../../assets/home/tocilice.jpg";
import { useTranslation } from "react-i18next";
import {
  Background,
  SplitDiv,
  AbutUsHeader,
  AbutUsTitle,
  SplitWrapper,
  CreamLine,
  BlueText,
  AbutUsGroups,
  AboutUsGroupTitle,
} from "./styles";
import { GroupWrapper, GroupDescription } from "../../screens/Shop/styles";

const AboutUs = ({ ...props }) => {
  const { t, i18n } = useTranslation();
  var language = i18n.language;

  return (
    <Background id="AboutUs">
      <AbutUsHeader>
        <AbutUsTitle>{t("lifeIsTooShort")}</AbutUsTitle>
      </AbutUsHeader>
      <div>
        <AbutUsGroups>
          {props.allGroups.length
            ? props.allGroups.map((item) => (
                <GroupWrapper key={`${item.id}_${item.name}`}>
                  <Link
                    to={`/group/${item.id}`}
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    <img
                      src={item.image}
                      alt={item.name}
                      style={{
                        width: "100%",
                        maxWidth: "800px",
                      }}
                    />
                    <AboutUsGroupTitle>
                      {language === "en"
                        ? item.name
                        : language === "fr"
                        ? item.name_fr
                        : language === "de"
                        ? item.name_de
                        : language === "it"
                        ? item.name_it
                        : item.name}
                    </AboutUsGroupTitle>
                    <GroupDescription>
                      {language === "en"
                        ? item.description
                        : language === "fr"
                        ? item.description_fr
                        : language === "de"
                        ? item.description_de
                        : language === "it"
                        ? item.description_it
                        : item.description}
                    </GroupDescription>
                  </Link>
                </GroupWrapper>
              ))
            : null}
        </AbutUsGroups>
      </div>
      <img
        src={LogoImg}
        alt="Bacchus drinks Logo"
        style={{ maxWidth: "300px", width: "90%", marginBottom: "50px" }}
      ></img>
      <SplitWrapper>
        <SplitDiv centered>
          <img src={TociliceImg} alt="Taps" style={{ width: "80%" }}></img>
        </SplitDiv>
        <SplitDiv>
          <CreamLine>{t("whoWeAre")}</CreamLine>
          <BlueText>
            <strong>
              <em>Bacchus Drinks</em>
            </strong>
            {t("bacchusBuildUpService")}
          </BlueText>
          <BlueText>
            <strong>
              <em>Bacchus Drinks</em>
            </strong>
            {t("bacchusSuppliesNature")}
          </BlueText>
          <BlueText>{t("exclusiveConnectionItalian")}</BlueText>
          <br></br>
          <CreamLine>{t("ourIdeologies")}</CreamLine>
          <BlueText>{t("doubtStartQuestion")}</BlueText>
          <br></br>
          <CreamLine>{t("ourGoal")}</CreamLine>
          <BlueText>{t("inspiredGreatTasting")}</BlueText>
        </SplitDiv>
      </SplitWrapper>
    </Background>
  );
};

export default AboutUs;
